import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { IncidentAdminComponent } from './incident-admin.component';

const routes: Routes = [
  { path: '', component: IncidentAdminComponent, data: { title: 'Incident Admin' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IncidentAdminRoutingModule {}

@NgModule({
  imports: [
    IncidentAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [IncidentAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IncidentAdminModule {}
